import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJustcallRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 31 31",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#03008F",
			d: "M5.541 10.305 3.144 12.35c-.338.29-.338.812 0 1.102l2.397 2.033"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#004CE6",
			d: "m24.449 18.705 2.397-2.045c.338-.29.338-.812 0-1.102l-2.397-2.034"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#004CE6",
			d: "M18.145 7.163c-.253 0-.49.046-.735.073a6.3 6.3 0 0 1 .735 2.876v7.531c0 3.209-2.439 5.826-5.57 6.19a6.3 6.3 0 0 0 5.57 3.39c3.482 0 6.306-2.807 6.306-6.263v-7.531c0-3.46-2.824-6.266-6.306-6.266Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#03008F",
			d: "M11.847 20.961v-7.53c0-3.209 2.439-5.826 5.57-6.19a6.3 6.3 0 0 0-5.57-3.39C8.365 3.851 5.541 6.658 5.541 10.114v7.53c0 3.46 2.824 6.263 6.306 6.263.249 0 .49-.046.731-.073a6.3 6.3 0 0 1-.731-2.873Z"
		})
	]
});
export default SvgJustcallRegularIcon;
